import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LOGOUT } from '../../constants/actions/auth.constants';
import NotificationService from '../services/NotificationService';
import type { INotification } from '../../types/common/INotification';

const NAME = 'notifications';

const initialState: INotification[] = NotificationService.getNotifications();

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {
        push: (state, action: PayloadAction<INotification>) => {
            state.push(action.payload);
        },
        pop: (state, action: PayloadAction<number>) => {
            const index = state.findIndex(
                (item) => item.timestamp === action.payload,
            );
            if (index >= 0) {
                state.splice(index, 1);
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(LOGOUT, () => []);
    },
});

const NotificationsSlice = {
    reducer: slice.reducer,
    actions: slice.actions,
};

export default NotificationsSlice;
